import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import {RouteWithLayout} from './components';
import {PrivateRouteWithLayout} from './components';
import {Main as MainLayout, Minimal as MinimalLayout} from './layouts';

import {
    Dashboard as DashboardView,
    Daily as DailyView,
    Weekly as WeeklyView,
    Monthly as MonthlyView,
    Request as RequestView,
    Management as ManagementView,
    Best as BestView,
    Screenshot as ScreenshotView,
    Frequency as FrequencyView,
    UserList as UserListView,
    Account as AccountView,
    Settings as SettingsView,
    Palette,
    SignUp as SignUpView,
    SignIn as SignInView,
    NotFound as NotFoundView
} from './views';

const Routes = () => {
    return (
        <Switch>
            <Redirect
                exact
                from="/"
                to="/dashboard"
                title="ECDI Report - Dashboard"
            />
            <Redirect
                exact
                from="/ecdi"
                to="/ecdi/daily"
                title="ECDI Report - Daily"
            />
            <PrivateRouteWithLayout
                component={DashboardView}
                exact
                layout={MainLayout}
                path="/dashboard"
                title="ECDI Report - Dashboard"
            />
            <PrivateRouteWithLayout
                component={DailyView}
                exact
                layout={MainLayout}
                path="/ecdi/daily"
                title="ECDI Report - Daily"
            />
            <PrivateRouteWithLayout
                component={WeeklyView}
                exact
                layout={MainLayout}
                path="/ecdi/weekly"
                title="ECDI Report - Weekly"
            />
            <PrivateRouteWithLayout
                component={MonthlyView}
                exact
                layout={MainLayout}
                path="/ecdi/monthly"
                title="ECDI Report - Monthly"
            />
            <PrivateRouteWithLayout
                component={UserListView}
                exact
                layout={MainLayout}
                path="/users"
                title="ECDI Report - Users"
            />
            <PrivateRouteWithLayout
                component={AccountView}
                exact
                layout={MainLayout}
                path="/account"
                title="ECDI Report - Account"
            />
            <PrivateRouteWithLayout
                component={SettingsView}
                exact
                layout={MainLayout}
                path="/settings"
                title="ECDI Report - Settings"
            />
            <Redirect
                exact
                from="/category"
                to="/category/request"
                title="Category - Request permission"
            />
            <PrivateRouteWithLayout
                component={RequestView}
                exact
                layout={MainLayout}
                path="/category/request"
                title="Category - Request permission"
            />
            <PrivateRouteWithLayout
                component={ManagementView}
                exact
                layout={MainLayout}
                path="/category/management"
                title="Category - manage permission"
            />
            <PrivateRouteWithLayout
                component={BestView}
                exact
                layout={MainLayout}
                path="/best"
                title="ECDI Report - Best"
            />
            <PrivateRouteWithLayout
                component={ScreenshotView}
                exact
                layout={MainLayout}
                path="/screenshot"
                title="ECDI Report - Screenshot"
            />
            <PrivateRouteWithLayout
                component={FrequencyView}
                exact
                layout={MainLayout}
                path="/promotion/frequency"
                title="Promotion - Monthly Promotion Frequency"
            />
            <PrivateRouteWithLayout
                component={Palette}
                exact
                layout={MainLayout}
                path="/palette"
                title="Palette"
            />
            <RouteWithLayout
                component={SignUpView}
                exact
                layout={MinimalLayout}
                path="/sign-up"
                title="ECDI Report - Sign Up"
            />
            <RouteWithLayout
                component={SignInView}
                exact
                layout={MinimalLayout}
                path="/sign-in"
                title="ECDI Report - Sign In"
            />
            <RouteWithLayout
                component={NotFoundView}
                exact
                layout={MinimalLayout}
                path="/not-found"
                title="ECDI Report - Not Found"
            />
            <Redirect to="/not-found"/>
        </Switch>
    );
};

export default Routes;
